// src/pages/Home.js

import React from "react";
import "./Home.css";
import { FaStethoscope, FaBook, FaQuestionCircle } from "react-icons/fa";
import Posts from "./Posts";
import AppShowreel from "../components/AppShowreel";

function Home() {
  return (
    <div className="homeContainer">
      <header>
        <div>
          <h1 className="main-title">Benmed</h1>
        </div>
        <h2 className="subtitle">Medical App Development</h2>
      </header>

      <section className="contact">
        <a href="mailto:ben@benmed.org" className="email-link">
          <span className="email-icon">📧</span> Get in Touch: ben@benmed.org
        </a>
      </section>

      {/* Showreel of apps horizontally */}
      <AppShowreel />

      {/* Blog Posts (limit to 10) */}
      <Posts showOnHome={true} />
    </div>
  );
}

export default Home;